// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "close-1N2tn";
export { _1 as "__esModule", _2 as "close" }
export default { "__esModule": _1, "close": _2 }
